<template>
  <div class="layer notranslate" @click="close">
    <div class="inner">
      <div class="timeNow">
        <div>
          {{timeNow}}
          <div class="timezone">({{timezone}})</div>
        </div>
      </div>
      <ul class="availableTableList">
        <li v-for="(day, index) in timeTable"
          :key="day.id"
          :data-day="setDay(index)"
          :class="{today: isToday(index), disabled: isDayOff(day)}">
          <div class="day">{{setDay(index)}}</div>
          <div class="timeTable">
            <div v-if="!isDayOff(day)" class="timeTableBox">
              <div v-for="(time, i) in day.time"
                :key="i"
                 class="timeTableItem">{{time.from}} ~ {{time.to}}</div>
            </div>
            <span v-else class="disabled">day off</span>
          </div>
          <!-- <span class="disabled">day off</span> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import moment from 'moment-timezone'

export default {
  props: [
    'locale',
    'table'
  ],
  computed: {
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm'
      return `${this.dateFormat} ${time}`
    }
  },
  created () {
    this.timeNow = DateTime.fromISO(moment().toISOString(), { zone: this.timezone }).toFormat(this.format)
    let timerId = setInterval(() => {
      const datetime = DateTime.fromISO(moment().toISOString(), { zone: this.timezone })
      this.timeNow = datetime.toFormat(this.format)
    }, 60000)
    function getOvertime (time) {
      const timeFrom = parseInt(time.from.replace(':', ''))
      const timeTo = parseInt(time.to.replace(':', ''))
      const isOvertime = timeFrom > timeTo
      return isOvertime
    }
    if (this.table) {
      this.timeTable = this.table.map(x => x)
      /**
       * 구 데이터 중 익일로 넘어가는 시간대가 있었음(21:00 ~ 06:00)
       * 이 시간을 자정으로 쪼개어 다음날로 넘김
       */
      for (let i = 0; i < this.timeTable.length; i++) {
        const day = this.timeTable[i]
        const nextDay = i === this.timeTable.length - 1 ? this.timeTable[0] : this.timeTable[i + 1]
        const times = day.time
        for (let t = 0; t < times.length; t++) {
          const time = times[t]
          const timeTo = time.to
          if (getOvertime(time)) { // 익일로 넘어가면
            time.to = '24:00' // 오늘은 자정까지
            nextDay.time.unshift({ // 다음날은 자정부터 to까지
              from: '00:00',
              to: timeTo
            })
          }
        }
      }
    }
  },
  data () {
    return {
      timeNow: '',
      timeTable: []
    }
  },
  methods: {
    isToday (index) {
      const today = moment().isoWeekday() - 1
      return index === today
    },
    setDay (index) { // mon: 0 ~ sun: 6
      let result
      switch (index) {
        case 0:
          result = 'Mon'
          break
        case 1:
          result = 'Tue'
          break
        case 2:
          result = 'Wed'
          break
        case 3:
          result = 'Thu'
          break
        case 4:
          result = 'Fri'
          break
        case 5:
          result = 'Sat'
          break
        case 6:
          result = 'Sun'
          break
        default:
          result = ''
      }
      return result
    },
    isDayOff (day) {
      return !day.available || !(day.time && day.time.length)
    },
    close (e) {
      e.stopPropagation()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  white-space: initial;
  .inner {
    height: auto;
    max-width: 320px;
    border-radius: 10px;
    opacity: 1 !important;
  }
}
.timeNow {
  margin-bottom: 10px;
  line-height: 1.3;
  text-align: center;
  .timezone {
    font-size: 12px;
    opacity: 0.5;
  }
}
.availableTableList {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 14px;
  list-style: none !important;
  li {
    display: flex;
    position: relative;
    list-style: none;
    text-indent: 0;
    padding: 15px;
    color: $color-white;
    border-radius: 18px;
    background-color: rgba($color-green, 0.75);
    & + li {
      margin-top: 5px;
    }
    &.today {
      background-color: $color-green;
      box-shadow: inset 0 0 0 2px rgba(0,0,0,0.3);
      .day:before {
        content: "\2714";
        position: absolute;
        left: -4px;
        font-weight: bold;
      }
    }
    &.disabled {
      background-color: $color-lgrey;
    }
    .day {
      position: relative;
      width: 4em;
      margin-right: 1em;
      text-align: center;
      border-right: 1px solid rgba($color-white, 0.5);
    }
  }
}
</style>
